import { Router } from 'express';
import * as controller from './settings.controller';
import { authMiddleware } from '../../middleware/auth.middleware';
import { requirePermission } from '../../middleware/rbac.middleware';

const router = Router();
router.use(authMiddleware);

router.post('/companies', requirePermission('create_company'), controller.createCompany);
router.get('/companies', controller.listCompanies);
router.patch('/companies/:id', requirePermission('edit_company'), controller.updateCompany);
router.delete('/companies/:id', requirePermission('delete_company'), controller.deleteCompany);

router.post('/departments', requirePermission('create_department'), controller.createDepartment);
router.get('/departments', controller.listDepartments);
router.patch('/departments/:id', requirePermission('edit_department'), controller.updateDepartment);
router.delete('/departments/:id', requirePermission('delete_department'), controller.deleteDepartment);

router.post('/policies', controller.createPolicy);
router.get('/policies', controller.listPolicies);
router.get('/policies/:id', controller.getPolicy);
router.patch('/policies/:id', controller.updatePolicy);
router.delete('/policies/:id', controller.deletePolicy);

export default router;

